import { PlusCircleIcon } from "@heroicons/react/24/outline";
import SelectComponent from "@via/components/select/select";
import Table, { TableSize } from "@via/components/table/table";
import { EditProcessToolbar } from "@via/pages/projects/pipelines/workflow/components/edit-process-toolbar.tsx";
import {
  EditProcessGroupTypes,
  QualifierOptionsEnum,
} from "@via/pages/projects/pipelines/workflow/utils/constants.tsx";
import { SelectOption } from "@via/utils/interfaces";
import { useEffect, useState } from "react";

export default function Parameter({
  draft,
  parameters,
  inputColumns,
  outputColumns,
  canEditProcess,
  onCreateParameter,
  onEditParameter,
  onDeleteParameter,
  handleNewInputParameter,
  handleNewOutputParameter,
}) {
  const [selectedInputParameter, setSelectedInputParameter] =
    useState<SelectOption | null>(null);
  const [selectedOutputParameter, setSelectedOutputParameter] =
    useState<SelectOption | null>(null);

  useEffect(() => {
    setSelectedInputParameter(null);
    setSelectedOutputParameter(null);
  }, [draft?.inputParameters?.length, draft?.outputParameters?.length]);

  return (
    <>
      <div className="mt-4 flex flex-row items-center">
        <label className="w-24 text-sm font-medium leading-6 text-gray-900">
          Parameters
        </label>
        <EditProcessToolbar
          type={EditProcessGroupTypes.Parameters}
          readOnly={!canEditProcess}
          onCreate={onCreateParameter}
          onEdit={onEditParameter}
          onDelete={onDeleteParameter}
        />
      </div>
      <div className="flex flex-row items-start pt-2">
        <div>
          <Table
            data={draft?.inputParameters}
            columns={inputColumns}
            enableSorting={false}
            showPagination={false}
            pageSize={100}
            size={TableSize.Small}
            applyColumnSize={true}
          />
          <div className="w-80 pr-3">
            <SelectComponent
              value={selectedInputParameter}
              onChange={val => {
                setSelectedInputParameter(val as SelectOption);
                handleNewInputParameter(val);
              }}
              enableClear={true}
              readOnly={!canEditProcess}
              name="newInputParameter"
              placeholder="Add Input Parameter"
              showFullSelectedText
              options={
                parameters?.map(option => ({
                  label:
                    option.qualifier === QualifierOptionsEnum.Val
                      ? `${option.name} \n (${option.qualifier})`
                      : `${option.name} \n (${option.fileType}, ${option.qualifier})`,
                  value: option.id,
                })) ?? []
              }
              rules={{ required: true }}
              prefixIcon={<PlusCircleIcon className="h-5 w-5 text-gray-400" />}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row items-start pt-2">
        <div>
          <Table
            data={draft?.outputParameters}
            columns={outputColumns}
            enableSorting={false}
            showPagination={false}
            pageSize={100}
            size={TableSize.Small}
            applyColumnSize={true}
          />
          <div className="w-80 pr-3">
            <SelectComponent
              value={selectedOutputParameter}
              onChange={val => {
                setSelectedOutputParameter(val as SelectOption);
                handleNewOutputParameter(val);
              }}
              enableClear={true}
              readOnly={!canEditProcess}
              name="newOutputParameter"
              placeholder="Add Output Parameter"
              showFullSelectedText
              options={
                parameters?.map(option => ({
                  label:
                    option.qualifier === QualifierOptionsEnum.Val
                      ? `${option.name} \n (${option.qualifier})`
                      : `${option.name} \n (${option.fileType}, ${option.qualifier})`,
                  value: option.id,
                })) ?? []
              }
              rules={{ required: true }}
              prefixIcon={<PlusCircleIcon className="h-5 w-5 text-gray-400" />}
            />
          </div>
        </div>
      </div>
    </>
  );
}
